import Proxy from '../Proxy';

class StatsDiscountProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('stats/by-discount', parameters);
  }

  list() {
    return this.submit('get', `${this.endpoint}`);
  }
}

export default StatsDiscountProxy;
